import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PlayerAvatar from './PlayerAvatar';
import EmptyState from './EmptyState';
import tokens from '../../theme/tokens';

const medalhas = [tokens.color.gold, '#9CA3AF', '#B7791F'];

// Lista ranqueada de jogadores: posição, foto, nome e valor à direita.
const RankingList = ({ items = [], valueKey, suffix = '', empty = 'Sem dados ainda', color, limit = 10 }) => {
  if (items.length === 0) return <EmptyState title={empty} />;
  return (
    <Stack spacing={1}>
      {items.slice(0, limit).map((item, index) => (
        <Stack key={`${item.nome}-${index}`} direction="row" spacing={1.5} alignItems="center">
          <Box sx={{ width: 24, height: 24, borderRadius: '50%', display: 'grid', placeItems: 'center', fontSize: 12, fontWeight: 700, bgcolor: index < 3 ? medalhas[index] : 'transparent', color: index < 3 ? '#fff' : 'text.secondary' }}>
            {index + 1}
          </Box>
          <PlayerAvatar src={item.foto} name={item.nome} size={34} />
          <Typography variant="body2" fontWeight={600} sx={{ flexGrow: 1, minWidth: 0 }} noWrap>{item.nome}</Typography>
          <Typography fontWeight={700} sx={{ color: color || 'text.primary', fontFamily: tokens.font.display, fontSize: '1.2rem' }}>
            {item[valueKey]}{suffix}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default RankingList;
